/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import createDismissFlagService, { dismissFlag as dismissFlagAction } from './dismiss/index.tsx';
import createShowFlagService from './show/index.tsx';
import { store } from './store/index.tsx';
import {
	type Action,
	type FlagServiceHook,
	type FlagService,
	type FlagId,
	type ShowFlagFn,
	type DismissFlag,
	type Flag,
	type FlagComponent,
	type FlagConfiguration,
	type FlagCustom,
	DISMISS_COMMAND,
} from './types.tsx';

export const showFlag: ShowFlagFn = createShowFlagService(store.dispatch);
export const dismissFlag: (dismissFlag: DismissFlag) => void = createDismissFlagService(
	store.dispatch,
);

const dismissFlagById = (id: FlagId) => {
	dismissFlag(dismissFlagAction(id));
};

const hasFlag = (id: FlagId) =>
	Boolean(
		store
			.getState()
			.flags.find((flagInstance) => 'id' in flagInstance.flag && flagInstance.flag.id === id),
	);

export const flagService: FlagService = { showFlag, dismissFlag };

export const useFlagsService = (): FlagServiceHook => ({
	showFlag,
	dismissFlag: dismissFlagById,
	hasFlag,
});

export const useFlagService = (): FlagService => flagService;

export const isDismissFlag = (flag?: Flag | DismissFlag): flag is DismissFlag =>
	typeof flag === 'object' && 'command' in flag && flag.command === DISMISS_COMMAND;

export const isFlagComponent = (flag?: Flag | DismissFlag): flag is FlagComponent =>
	typeof flag === 'function' && !('type' in flag) && !('render' in flag);

export const isFlagCustom = (flag?: Flag | DismissFlag): flag is FlagCustom =>
	typeof flag === 'object' && 'render' in flag && typeof flag.render === 'function';

export const isFlagConfiguration = (flag?: Flag | DismissFlag): flag is FlagConfiguration =>
	!isDismissFlag(flag) && !isFlagComponent(flag) && !isFlagCustom(flag);

export const isBatchAction = (action: Action): boolean =>
	'meta' in action &&
	action.meta &&
	action.meta.batch &&
	'payload' in action &&
	Array.isArray(action.payload);
